import { IGetValueArgs } from "@components/smart/FieldInfo";
import { IProformaInvoiceIssuedEntity, IProformaInvoiceReceivedEntity } from "@odata/GeneratedEntityTypes";
import { SAVED_VATS_PATH } from "@pages/admin/vatRules/VatRules.global.utils";

import { TValue } from "../../../global.types";
import { FormStorage } from "../../../views/formView/FormStorage";

export type IProformaEntity = (IProformaInvoiceReceivedEntity | IProformaInvoiceIssuedEntity) & {
    [SAVED_VATS_PATH]?: TValue
};

export function isDDOP({ data, storage }: IGetValueArgs): boolean {
    const entity = (data ?? (storage as FormStorage).data?.entity) as IProformaEntity;
    return !!entity.IsTaxDocument;
}